import { getHelpCenterAri } from '@atlassian/help-center-common-util/meta';

export const getProductIdentifierAttributes = (experienceId: string) => ({
    experienceId,
    helpcenterId: getHelpCenterAri().split('/').pop(),
});
